import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class SelectSuggestionByKeyboardService {
  private keydown$ = new Subject<KeyboardEvent>();
  private ssgSelected: boolean;

  get keyDownObservable(): Observable<KeyboardEvent> {
    return this.keydown$.asObservable();
  }

  pushKeyboardUpdate(event: KeyboardEvent): void {
    this.keydown$.next(event);
  }

  setSsgSelected() {
    this.ssgSelected = true;
  }

  resetSsgSelected() {
    this.ssgSelected = false;
  }

  isSsgSelected() {
    return this.ssgSelected;
  }
}
